import { login, recoverPassword, getPermissions, getAllAirportsByPermission } from '../../shared/auth-service';
import { getAirports } from '../../shared/data-services/airport-service';

export async function validateUser(user, password, isRecoverPassword, setMessage, setOpen, handleCompanies) {

  var validationMessage = '';

  if (isRecoverPassword) {
    if (user === '' || user === null)
      validationMessage = 'Ingrese su usuario';
  }
  else {
    if (user === '' || user === null && password === '' || password === null)
      validationMessage = 'Ingrese su usuario y clave';
    else if (user === '' || user === null)
      validationMessage = 'Ingrese su usuario';
    else if (password === '' || password === null)
      validationMessage = 'Ingrese su clave';
  }

  if (validationMessage !== '') {
    //setMessage(validationMessage);
     setMessage(`
        <div style="text-align: center;">
          <div font-size: 1rem; margin-bottom: 8px;">
            ${validationMessage}
          </div>
        </div>
      `);

    setOpen(true);
    return;
  }

  const result = await login(user, password, isRecoverPassword);

  if (result) {
    if (result.message === 'Ok') {
      var storedUser = "";
      var companies = "";
      if (sessionStorage.getItem("data-user") !== null)
        storedUser = JSON.parse(sessionStorage.getItem('data-user')) || {};
      else
        storedUser = JSON.parse(sessionStorage.getItem('user')) || {};
      
      companies = storedUser.companies || [];

      if (!storedUser.passwordChanged) {
        window.location = "/"; 
        return;
      }


      if (companies.length > 1 && !isRecoverPassword) 
        handleCompanies(companies); // Mostrar lista de compañías si hay más de 1
      else if (companies.length === 1 || isRecoverPassword) {
        sessionStorage.setItem("selectedCompany", JSON.stringify(companies[0])); // Guardar la única compañía
        window.location = "/"; // Redirigir al Home
      }

      return;
    }

    //setMessage(result.message);
     setMessage(`
        <div style="text-align: center;">
          <divfont-size: 1rem; margin-bottom: 8px;">
            ${result.message}
          </div>
        </div>
      `);
    setOpen(true);
  }
};

export async function getAirportsByPermission (employeeId, companyId){
  const data = await getAllAirportsByPermission(employeeId, companyId);
  return data;
};

export async function getAllPermissions (employeeId, companyId){
  const data = await getPermissions(employeeId, companyId);
  return data;
};